import './ContentBuilderTemplate.scss';

import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { TestimonialsSection } from '../../TestimonialsSection';
import { cnContentBuilderTemplate } from './index';
import { IRoot39 } from './models/CTI_39.props';

export const ContentBuilderTemplate: React.FC<IRoot39> = props => {
  const { title, video, background, contentId } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  return (
    <>
      {video && video.length > 0 && (
        <div
          className={cnContentBuilderTemplate('CustomTestimonials')}
          id={contentId}
        >
          <TestimonialsSection
            title={title}
            items={video}
            background={background}
          />
        </div>
      )}
    </>
  );
};

export default ContentBuilderTemplate;
